import {
  del,
  get,
  patch,
  post,
  type RequestConfig,
} from "../shared/api-client";
import type {
  ApiItemResponse,
  ListQuery,
  PaginatedResult,
} from "@project/types/location";
import type {
  GaushalaScheme,
  GaushalaSchemePayload,
} from "@project/types/gaushala";
import {
  JIVANDHARA_BASE,
  SILENT_LIST,
  fetchListPage,
  unwrapItem,
} from "./list-api-helpers";

const BASE = `${JIVANDHARA_BASE}/gaushala-schemes`;
const SILENT: RequestConfig = { showNotification: false };

class GaushalaSchemeService {
  listPage = (
    query: ListQuery = {}
  ): Promise<PaginatedResult<GaushalaScheme>> =>
    fetchListPage<GaushalaScheme>(`${BASE}/`, query);

  get = async (id: number): Promise<GaushalaScheme | undefined> => {
    const data = await get<ApiItemResponse<GaushalaScheme> | GaushalaScheme>(
      `${BASE}/${id}/`,
      SILENT_LIST
    );
    return unwrapItem(data);
  };

  create = async (payload: GaushalaSchemePayload): Promise<GaushalaScheme> => {
    const data = await post<
      ApiItemResponse<GaushalaScheme> | GaushalaScheme,
      GaushalaSchemePayload
    >(`${BASE}/`, payload, SILENT);
    const item = unwrapItem(data);
    if (!item) {
      throw new Error("Failed to create gaushala scheme.");
    }
    return item;
  };

  update = async (
    id: number,
    payload: Partial<GaushalaSchemePayload>
  ): Promise<GaushalaScheme | undefined> => {
    const data = await patch<
      ApiItemResponse<GaushalaScheme> | GaushalaScheme,
      Partial<GaushalaSchemePayload>
    >(`${BASE}/${id}/`, payload, SILENT);
    return unwrapItem(data);
  };

  delete = async (id: number): Promise<void> => {
    await del(`${BASE}/${id}/`, SILENT);
  };
}

export const gaushalaSchemeService = new GaushalaSchemeService();
